// extracted by mini-css-extract-plugin
module.exports = {"newsFeed":"NewsFeedPage_newsFeed__1mCx1","posts":"NewsFeedPage_posts__yEHFf"};